export const strings = {
  res_login: 'Prijava',
  res_register: 'Registracija',
  res_register2: 'Registriraj se',
  res_loginYouself: 'Prijavi se',
  res_registerYourself: 'Izradi korisnički račun',
  res_forgotPassword: 'Zaboravili ste lozinku?',
  res_dontHaveAnAccountRegister: 'Nemate korisnički račun?',
  res_restrictedArea: 'Nemate pristup!',
  res_passwordReset: 'Email poslan',
  res_checkEmailPassword: 'Provjerite email i password',
  res_enterEmailPasswordReset: 'Unesite email i resetirati ćemo lozinku',
  res_cancel: 'Odustani',
  res_cancelAlt: 'Otkaži',
  res_reset: 'Resetiraj',
  res_emailDoesNotExist: 'Korisnik s unesenom email adresom nije pronađen',
  res_lastName: 'Prezime',
  res_firstName: 'Ime',
  res_email: 'Email',
  res_changePassword: 'Promijeni lozinku',
  res_alreadyHaveAnAccount: 'Imaš korisnički račun? Prijavi se',
  res_registerTermOfService: 'Registracijom pristajete na naše',
  res_termsOfUseAlt: 'Uvjete korištenja',
  res_termsOfUse: 'Uvjeti korištenja',
  res_partnerBusinessTerms: 'Wasp opći uvjeti poslovanja za partnere',
  res_iAmAnOwner: 'Poslovni korisnik',
  res_myProfile: 'Moj profil',
  res_logout: 'Odjavi se',
  res_addPlace: 'Dodaj prostor',
  res_ownersOfSpace: 'Vlasnici prostora',
  res_editPlace: 'Uredi prostor',
  res_homeSearchText: 'Ubodi najbolji prostor za event',
  res_homePartnerText1: 'Ubodi novu priliku.',
  res_homePartnerText2: 'Postani Wasp partner.',
  res_numberOfPeople: 'Broj osoba',
  res_eventType: 'Tip događaja',
  res_location: 'Lokacija',
  res_search: 'Pretraži',
  res_password: 'Lozinka',
  res_repeatPassword: 'Ponovi lozinku',
  res_currentPassword: 'Trenutna lozinka',
  res_newPassword: 'Nova lozinka',
  res_passwordsDoNotMatch: 'Lozinke se ne podudaraju',
  res_firstLastName: 'Ime i prezime',
  res_companyName: 'Naziv tvrtke',
  res_companyAddress: 'Adresa sjedišta tvrtke',
  res_companyOIB: 'OIB tvrtke',
  res_phoneNumber: 'Broj telefona',
  res_venueName: 'Ime objekta',
  res_venueAddress: 'Adresa objekta',
  res_venueStreet: 'Ulica i kućni broj',
  res_objectType: 'Tip objekta',
  res_spaceType: 'Tip prostora',
  res_clearFilters: 'Očisti filtere',
  res_city: 'Grad',
  res_postalCode: 'Poštanski broj',
  res_seatingCapacity: 'Maksimalan kapacitet sjedećih mjesta',
  res_standingCapacity: 'Maksimalan kapacitet stajaćih mjesta',
  res_totalCapacity: 'Maksimalan kapacitet ukupno',
  res_totalFloorSpace: 'Ukupna površina objekta',
  res_insideFloorSpace: 'Ukupna površina unutarnjeg prostora',
  res_outsideFloorSpace: 'Ukupna površina vanjskog prostora',
  res_description: 'Opis',
  res_generalInfo: 'Opće informacije',
  res_venueInfo: 'Informacije o objektu',
  res_capacityInfo: 'Obilježja kapaciteta objekta',
  res_workHours: 'Radno vrijeme',
  res_venueSpecification: 'Specifikacije objekta',
  res_photos: 'Fotografije',
  res_save: 'Spremi',
  res_footerLogoText: 'Ubodi najbolji prostor za event.',
  res_monday: 'Ponedjeljak',
  res_tuesday: 'Utorak',
  res_wednesday: 'Srijeda',
  res_thursday: 'Četvrtak',
  res_friday: 'Petak',
  res_saturday: 'Subota',
  res_sunday: 'Nedjelja',
  res_mondayShort: 'Pon.',
  res_tuesdayShort: 'Uto.',
  res_wednesdayShort: 'Sri.',
  res_thursdayShort: 'Čet.',
  res_fridayShort: 'Pet.',
  res_saturdayShort: 'Sub.',
  res_sundayShort: 'Ned.',
  res_send: 'Pošalji',
  res_contact: 'Kontakt',
  res_forPartners: 'Za partnere',
  res_privacyStatement: 'Izjava o privatnosti',
  res_opened: 'Otvoreno',
  res_closed: 'Zatvoreno',
  res_message: 'Poruka',
  res_active: 'Aktivan',
  res_notActive: 'Nije aktivan',
  res_edit: 'Uredi',
  res_inProcess: 'U obradi',
  res_notProcessed: 'Nije obrađeno',
  res_noSearchResults: 'Nema rezultata pretrage',
  res_spaceCharacteristics: 'Karakteristike prostora',
  res_showLess: ' - Prikaži manje',
  res_showMore: ' + Prikaži više',
  res_spaceLeaseOptions: 'Mogućnost zakupa prostora',
  res_spaceLease: 'Zakup prostora',
  res_whatAreYouOrganizing: 'Što organiziraš?',
  res_exploreLocations: 'Istraži prostore po lokacijama',
  res_bannerLookingForPlaceTitle: 'Tražiš prostor za organizaciju događaja?',
  res_bannerLookingForPlaceText:
    'Potraži jedinstveni prostor za svoj događaj i jednostavno dođi do informacije putem opsežnih filtera.',
  res_bannerAddPlaceTitle: 'Imaš super prostor za događaj?',
  res_bannerAddPlaceText:
    'Wasp platforma ti pomaže ostvariti više bookinga. Dodaj svoj prostor putem aplikacije i brzo dođi do svojih klijenata.',
  res_eventTypeForOrganization: 'Tip događaja koji se može organizirati',
  res_offerFeatures: 'Obilježja ponude',
  res_close: 'Zatvori',
  res_offers: 'Ponuda',
  res_maxEventPeople: 'Maksimalan broj osoba koje mogu prisustvovati događaju',
  res_minEventPeople: 'Minimalan broj osoba za zakup prostora',
  res_hourlyPrice: 'Minimalna cijena zakupa prostora po satu (EUR) s uključenim PDV-om',
  res_dailyPrice: 'Minimalna cijena zakupa prostora po danu (EUR) s uključenim PDV-om',
  res_notPossible: 'Nije moguće',
  res_workingHoursNotice: 'Dani s neispunjenim radnim vremenom biti će automatski spremljeni kao zatvoreni.',
  res_seatingPlaces: 'Sjedećih mjesta',
  res_standingPlaces: 'Stajaćih mjesta',
  res_maxCapacity: 'Maksimalni kapacitet',
  res_innerSpaceArea: 'Unutarnjeg prostora',
  res_outerSpaceArea: 'Vanjskog prostora',
  res_totalSpaceArea: 'Ukupna površina',
  res_imageUploadInfo: 'Klikni ili dovuci u ovaj prostor za upload',
  res_imageUploadRulesInfo:
    'Priložite najmanje 4, a najviše 10 fotografija prostora horizontalnog usmjerenja. Veličina jedne fotografije može biti maksimalno 5MB.',
  res_addMorePhotos: 'Dodaj još fotografija',
  res_noImages: 'Nema slika',
  res_imageDeleteInfo:
    'Akcija uklanjanja slike ne može se poništiti. Ukoliko ste uklonili krivu sliku uploadajte ju ponovo.',
  res_companyData: 'Podaci o tvrtki',
  res_sendRequest: 'Pošalji upit',
  res_name: 'Ime',
  res_date: 'Datum',
  res_from: 'Od',
  res_to: 'Do',
  res_listingAccessDenied: 'Nemate pristup ovom listingu',
  res_spaceLeaseInfo:
    'Zakup prostora po satu moguć je samo za događaje koji traju do 6 sati. Svi događaji u trajanju dužem od toga biti će obračunati prema cijeni za dnevni zakup što uključuje i sve višednevne događaje. Plaćanjem dnevnog zakupa korisnik ne ostvaruje cjelodnevni pristup prostoru, isti je dostupan u rezerviranom periodu.',
  res_partners_title: 'Prva specijalizirana platforma za najam prostora za događaje',
  res_activate: 'Aktiviraj',
  res_deactivate: 'Deaktiviraj',
  res_filters: 'Filteri',
  res_filter: 'Filtriraj',
  res_confirm: 'Potvrdi',
  res_expired: 'Isteklo',
  res_expiredUser: 'Upit je istekao',
  res_expiresIn: 'Ističe za',
  res_day: 'dan',
  res_days: 'dana',
  res_hours: 'h',
  res_hour: 'h',
  res_minutes: 'min',
  res_minute: 'min',
  res_cancelReservationTitle: 'Otkazivanje rezervacije',
  res_cancelReservationMessage: 'Molimo navedite razlog otkazivanja.',
  res_cancelReasonLabel: 'Razlog otkazivanja',
  res_cancelReasonPlaceholder: 'Npr: Dvostruka rezervacija, održavanje objekta, tehnički problemi...',
  res_confirmCancellation: 'Potvrdi otkazivanje',
  res_waitForOwnerConfirmation: 'Možete potvrditi nakon što objekt potvrdi raspoloživost',
  res_ownerConfirmationInfo: 'Nakon što potvrdite raspoloživost korisnik će moći potvrditi svoj dolazak',
};
